<template>
<div>
  <div class="rightWxts">
      <div class="title">
        温馨提示
      </div>

      <div class="t2">
        <div>
         1.请到“账号管理”界面完善个人信息，这将有利于为您快速登记学时证明；
        </div>
        <div>
          2.推荐使用360浏览器极速模式进行学习；
        </div>
        <div>
         3.课程学习通过后可到学习中心“继续教育”界面自主打印学时证明；
        </div>
        <div>
         4.如您需要发票请到“订单管理”界面点击“申请开票”，输入发票信息，申领电子发票。
        </div>
        <div>
        5.所报名班级下的所有课程全部学习完成才能生成证书。
        </div>
      </div>
  </div>

  <div class="fwhBox">
      <div class="f1">
        小程序二维码
      </div>
      <div>
        <img class="fwh" src="../../assets/images/ewm2.png" alt="">
      </div>
    </div>
</div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
export default {
// import引入的组件需要注入到对象中才能使用
components: {
},
data() {
// 这里存放数据
return {
};
},
// 监听属性 类似于data概念
computed: {},
 // 监控data中的数据变化
watch: {},
// 方法集合
methods: {},
// 生命周期 - 创建完成（可以访问当前this实例）
created() {},
// 生命周期 - 挂载完成（可以访问DOM元素）
mounted() {},
beforeCreate() {}, // 生命周期 - 创建之前
beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.rightWxts {
  width: 190px;
 // height: 378px;
  background: #FFFFFF;
  padding: 24px 20px 32px 20px;
  color: #333333;
  font-size: 14px;
  margin-left: 10px;
  .title {
    color: #4076F6;
    font-size: 16px;
  }
  .t2 {
    margin-top: 12px;
    line-height: 25px;
  }
}

.fwhBox {
  margin-top: 10px;
  width: 190px;
  height: 210px;
  background: #FFFFFF;
  padding: 20px 25px;
  margin-left: 10px;
  .f1 {
    color: #4076F6;
    font-size: 16px;
    text-align: center;
  }
  .fwh {
    width: 140px;
    height: 140px;
  }
}
</style>